import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { consumePostAuthPath, exchangeCode } from "../auth";

export function OAuthCallbackPage(): React.JSX.Element {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const errorParam = params.get("error_description") ?? params.get("error");
    if (errorParam) {
      setError(errorParam);
      return;
    }
    if (!code) {
      setError("Missing authorisation code");
      return;
    }
    exchangeCode(code)
      .then(() => {
        navigate(consumePostAuthPath(), { replace: true });
      })
      .catch((err) => setError(String(err)));
  }, [navigate]);

  if (error) return <div className="error">Sign-in failed: {error}</div>;
  return <div className="loading">Completing sign-in&hellip;</div>;
}
